import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const CardContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "80px 16px 16px",
    maxWidth: "900px",
    margin: "auto",
});

export const CenteredContainer = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
});